module.exports = __webpack_public_path__ + "img/56ne.b4c5a9b2.svg";